// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1SaYN","vLegacy":"SelectSecondary_vLegacy__3GXO2","error":"SelectSecondary_error__yzQ8p","disabled":"SelectSecondary_disabled__1Z4Ra"};